export default [
  {
      header: 'Content',
      resource: 'Blog',
      action: 'read',
   
  },
  {
    title: 'Blog',
    icon: 'BookOpenIcon',
   
    tagVariant: 'light-warning',
    resource: 'Blog',
    action: 'read',
    children: [
      {
          title: 'Blog',
          route: 'blog-read',  
      
          resource: 'Blog',
          action: 'read',
      },
      {
          title: 'Category',
          route: 'blog-category-read',  
          
          resource: 'Blog Categories',
          action: 'read',
      },

    ]
   
   
  },
  {
    title: 'Storage',
    icon: 'FileTextIcon',
    route: 'files-read',  
    tagVariant: 'light-warning',
    resource: 'Pages',
    action: 'read',
   
   
},
/*{
  title: 'Products',
  icon: 'BoxIcon',
 
  tagVariant: 'light-warning',
  resource: 'Products',
  action: 'read',
  children: [
    {
        title: 'Products',
        route: 'products-read',  
    
        resource: 'Products',
        action: 'read',
    },
    {
        title: 'Category',
        route: 'products-category-read',  
        
        resource: 'Product Categories',
        action: 'read',
    },

  ]
 
 
},
  {
      title: 'Portfolio',
      icon: 'FileIcon',
     
      tagVariant: 'light-warning',
      resource: 'Portfolios',
      action: 'read',
      children: [
        {
            title: 'Portfolios',
            route: 'portfolios-read',  
        
            resource: 'Portfolios',
            action: 'read',
        },
        {
            title: 'Category',
            route: 'portfolios-category-read',  
            
            resource: 'Portfolio Categories',
            action: 'read',
        },

      ]
     
     
    },{
      title: 'Service',
      iconflat: 'services',
     
      tagVariant: 'light-warning',
      resource: 'Services',
      action: 'read',
      children: [
        {
            title: 'Services',
            route: 'services-read',  
        
            resource: 'Services',
            action: 'read',
        },
        {
            title: 'Category',
            route: 'services-category-read',  
            
            resource: 'Services Categories',
            action: 'read',
        },

      ]
     
     
    },*/
    
    {
      title: 'Socials',
      iconflat: 'social',
     
      tagVariant: 'light-warning',
      resource: 'Socials',
      action: 'read',
      children: [
        {
            title: 'Socials',
            route: 'socials-read',  
        
            resource: 'Socials',
            action: 'read',
        },
        {
            title: 'Category',
            route: 'socials-category-read',  
            
            resource: 'Social Categories',
            action: 'read',
        },

      ]
     
     
    },
    
    {
      title: 'Packages',
      iconflat: 'package',
      route: 'packages-read',
      tagVariant: 'light-warning',
      resource: 'Packages',
      action: 'read',
    },
    
    /*{
      title: 'Promotions',
      iconflat: 'promotion',
     
      tagVariant: 'light-warning',
      resource: 'Promotions',
      action: 'read',
      children: [
        {
            title: 'Promotions',
            route: 'promotions-read',  
        
            resource: 'Promotions',
            action: 'read',
        },

      ]
     
     
    },

    {
      title: 'Vouchers',
      iconflat: 'voucher',
     
      tagVariant: 'light-warning',
      resource: 'Vouchers',
      action: 'read',
      children: [
        {
            title: 'Vouchers',
            route: 'vouchers-read',  
        
            resource: 'Vouchers',
            action: 'read',
        },

      ]
     
     
    },*/

    {
      title: 'Menu',
      iconflat: 'menu',
      tagVariant: 'light-warning',
      resource: 'Food',
      action: 'read',
      children: [
        {
            title: 'Category',
            route: 'food-category-read',  
            
            resource: 'Food',
            action: 'read',
        },
        {
          title: 'Sub Category',
          route: 'food-sub-category-read',  
          
          resource: 'Food',
          action: 'read',
        },
        {
          title: 'Allergy',
          route: 'food-allergy-read',  
          
          resource: 'Food',
          action: 'read',
        },
        {
          title: 'Menu',
          route: 'food-read',  
      
          resource: 'Food',
          action: 'read',
        },
      ]
    },

    {
      title: 'Rooms',
      iconflat: 'bed',
      tagVariant: 'light-warning',
      resource: 'Rooms',
      action: 'read',
      children: [
        {
            title: 'Rooms',
            route: 'rooms-read',  
        
            resource: 'Rooms',
            action: 'read',
        },
        {
            title: 'Amenity',
            route: 'amenities-read',  
            
            resource: 'Room Amenities',
            action: 'read',
        },
        {
          title: 'Feature',
          route: 'features-read',  
          
          resource: 'Room Features',
          action: 'read',
        },
      ]
    },
    {
      title: 'Guides',
      iconflat: 'guide',
      tagVariant: 'light-warning',
      resource: 'Guides',
      action: 'read',
      children: [
        {
            title: 'Guides',
            route: 'guides-read',  
        
            resource: 'Guides',
            action: 'read',
        },
        {
            title: 'Category',
            route: 'guide-category-read',  
            
            resource: 'Guide Categories',
            action: 'read',
        },
      ]
    },
    {
      title: 'Eat & Drinks',
      iconflat: 'food&drink',
      tagVariant: 'light-warning',
      resource: 'Eat',
      action: 'read',
      children: [
        {
          title: 'Eat & Drinks',
          route: 'eat-read',  
      
          resource: 'Eat',
          action: 'read',
        },
        {
          title: 'Icon',
          route: 'eat-icon-read',  
          
          resource: 'Eat Icons',
          action: 'read',
        },
      ]
    },
    {
      title: 'Facility',
      iconflat: 'facilities',
      tagVariant: 'light-warning',
      resource: 'Facility',
      action: 'read',
      children: [
        {
          title: 'Facility',
          route: 'facility-read',
      
          resource: 'Facility',
          action: 'read',
        },
        {
          title: 'Icon',
          route: 'facility-icon-read',
          
          resource: 'Facility Icons',
          action: 'read',
        },
      ]
    },
    {
      title: 'Offers',
      iconflat: 'offer',
      tagVariant: 'light-warning',
      resource: 'Offers',
      action: 'read',
      children: [
        {
          title: 'Offers',
          route: 'offers-read',  
      
          resource: 'Offers',
          action: 'read',
        },
        {
          title: 'Icon',
          route: 'offers-icon-read',  
          
          resource: 'Offer Icons',
          action: 'read',
        },
      ]
    },
    {
      title: 'Meeting & Events',
      iconflat: 'meeting&event',
      tagVariant: 'light-warning',
      resource: 'Meeting & Events',
      action: 'read',
      children: [
        {
          title: 'Meeting & Events',
          route: 'meeting-and-events-read',  
      
          resource: 'Meeting & Events',
          action: 'read',
        },
        {
          title: 'Icon',
          route: 'meeting-and-events-icon-read',  
          
          resource: 'Meeting & Events Icons',
          action: 'read',
        },
      ]
    },
    {
      title: 'Blogger Reviews',
      iconflat: 'review',
      route: 'review-read',
      tagVariant: 'light-warning',
      resource: 'Reviews',
      action: 'read',
    },
    {
      title: 'Awards',
      icon: 'BookOpenIcon',
      route: 'award-read',
      tagVariant: 'light-warning',
      resource: 'Award',
      action: 'read',
    },
    {
      title: 'Media Gallery',
      iconflat: 'media_gallery',
      route: 'media-gallery-read',
      tagVariant: 'light-warning',
      resource: 'Media Gallery',
      action: 'read',
    },

   /* {
      title: 'Publications',
      icon: 'LayoutIcon',
      route: 'publications-read',  
      tagVariant: 'light-warning',
      resource: 'Publications',
      action: 'read',
     
     
  },*/
  {
      title: 'Page',
      icon: 'FileTextIcon',
      route: 'pages-read',  
      tagVariant: 'light-warning',
      resource: 'Pages',
      action: 'read',
     
     
  },
  //{
  //    title: 'Feedback',
  //    icon: 'MessageCircleIcon',
  //    route: 'feedback-read',  
  //    tagVariant: 'light-warning',
  //    resource: 'Feedback',
  //    action: 'read',
  //},
  {
    title: 'Social Reviews',
    icon: 'MessageCircleIcon',
    route: 'comment-read',  
    tagVariant: 'light-warning',
    resource: 'Comment',
    action: 'read',
  },
  {
      title: 'Banner',
      icon: 'ImageIcon',
      route: 'banner-read',  
      tagVariant: 'light-warning',
      resource: 'Banner',
      action: 'read',
     
     
  },
 
  {
      title: 'Navigation',
      icon: 'NavigationIcon',
      route: 'navigation-read',  
      tagVariant: 'light-warning',
      resource: 'Navigation',
      action: 'read',
  
  
  },
  // {
  //     title: 'Widget',
  //     icon: 'ClipboardIcon',
  //     route: 'widgets-read',  
  //     tagVariant: 'light-warning',
  //     resource: 'Widgets',
  //     action: 'read',
  
  
  // },
]